import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface RelatedPost {
  title: string;
  description: string;
  slug: string;
  emoji: string;
}
interface RelatedBlogPostsProps {
  posts: RelatedPost[];
}
export function RelatedBlogPosts({
  posts
}: RelatedBlogPostsProps) {
  return <section className="mt-16 mb-12" data-id="element-690">
      <h2 className="text-3xl font-bold mb-8 tracking-tight" data-id="element-691">
        Continue Reading
      </h2>
      <div className="grid md:grid-cols-2 gap-6" data-id="element-692">
        {posts.map((post, index) => <Link key={index} to={`/blog/${post.slug}`} className="group bg-white rounded-2xl p-7 border border-gray-200 hover:border-gray-300 hover:shadow-lg transition-all duration-300" data-id="element-693">
            <div className="flex items-start justify-between mb-4" data-id="element-694">
              <span className="text-4xl" data-id="element-695">{post.emoji}</span>
              <ArrowRight size={20} className="text-gray-400 group-hover:text-gray-900 group-hover:translate-x-1 transition-all" data-id="element-696" />
            </div>
            <h3 className="font-bold text-xl mb-3 group-hover:text-gray-900 transition-colors leading-snug" data-id="element-697">
              {post.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-698">
              {post.description}
            </p>
          </Link>)}
      </div>
    </section>;
}